import { render, staticRenderFns } from "./SettingsBotThemeForm.vue?vue&type=template&id=7218abce&"
import script from "./SettingsBotThemeForm.vue?vue&type=script&lang=js&"
export * from "./SettingsBotThemeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports